import type { DeliveryEndReasonFilter } from "./FilterButton";

export const NO_DELIVERY_END_REASON = "NONE";
export const DELIVERY_END_REASONS: { id: string; name: string }[] = [
  { id: "FL", name: "Flytt" },
  { id: "LB", name: "Leverantörsbyte" },
  { id: "ES", name: "Ej signerat avtal" },
  { id: "CN", name: "Avbruten av nät" },
  { id: "NA", name: "Okänd anledning" },
  { id: "CO", name: "Avbruten av oss" },
  { id: NO_DELIVERY_END_REASON, name: "Ingen orsak" },
];

export const getDeliveryEndReasonLabel = (filter: DeliveryEndReasonFilter): string =>
  DELIVERY_END_REASONS.find((reason) => reason.id === filter)?.name ?? filter ?? "";
